import React, { useEffect, useState } from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useNavigate } from 'react-router-dom'
import { Card, CardHeader, CardBody, CardTitle, Table, Row, Col, Button } from 'reactstrap'

import { TableInteresMora } from './TableInteresMora/TableInteresMora'
import { FormInteresMora } from './FormInteresMora/FormInteresMora'

import { useFetchInteresMora } from '../Configuracion-Mora/hooks/useFetchInteresMora'

const ConfiguracionMora = () => {
    const navigate = useNavigate()

    // Hook: Para el select que trae todos los registros
    const [intereCredito, setInteresCredito] = useState([])

    // Hook: Para el select que recupera un solo registro
    const [intereCreditoSelected, setintereCreditoSelected] = useState({})

    // Hook: Para Mostrar/Ocultar el Formulario
    const [showForm, setShowForm] = useState(false)

    // Custom Hook: interacciones con la BD
    const { getInteresMora, createInteresMora, updateInteresMora, deleteInteresMora, getInteres } =
        useFetchInteresMora()

    // ejecuta el select a la BD para recuperar todos los registros
    const listarInteresCredito = async () => {
        const res = await getInteresMora()
        setInteresCredito(res)

        return res
    }

    useEffect(() => {
        listarInteresCredito()
    }, [])

    // Recupera la información de un registro en base a su ID cuando se selecciona desde la Tabla de datos
    const handleClickMostrarRegistro = async (idmora) => {
        // Recupera la información completa del registro seleccionado
        const res = await getInteres(idmora)
        setintereCreditoSelected({
            idmora: res.idmora,
            interes: res.interes,
            descripcion: res.descripcion
        })
        // Mostrar/Ocultar formulario
        handleClickMostrarForm()
    }

    // Muestra/Oculta el formulario
    const handleClickMostrarForm = () => {
        setShowForm(!showForm)
    }

    return (
        <AllowedAccess permissions={['ACCESOS', '49_ADMIN']} renderAuthFailed={<p>Error</p>}>
            <div className='content'>
                <div className={showForm ? 'd-none' : 'panel-body'} id='listadoregistros'>
                    <Row>
                        <Col md='12'>
                            <Card>
                                <CardHeader>
                                    <CardTitle tag='h4'>
                                        Interes Credito <i className='nc-icon nc-circle-10'></i>
                                    </CardTitle>
                                    <Button color='primary' onClick={handleClickMostrarForm}>
                                        Agregar
                                    </Button>
                                </CardHeader>
                                <CardBody>
                                    <TableInteresMora
                                        intereCredito={intereCredito}
                                        handleClickMostrarRegistro={handleClickMostrarRegistro}
                                        listarInteresCredito={listarInteresCredito}
                                        deleteInteresMora={deleteInteresMora}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <div className={!showForm ? 'd-none' : 'panel-body'} id='formularioregistros'>
                    <FormInteresMora
                        intereCreditoSelected={intereCreditoSelected}
                        handleClickMostrarForm={handleClickMostrarForm}
                        // Funciones
                        setintereCreditoSelected={setintereCreditoSelected}
                        listarInteresCredito={listarInteresCredito}
                        getInteres={getInteres}
                        createInteresMora={createInteresMora}
                        updateInteresMora={updateInteresMora}
                    />
                </div>
            </div>
        </AllowedAccess>
    )
}

export { ConfiguracionMora }
